import create from 'zustand'
import { devtools } from 'zustand/middleware'
import immer from "./immer"

let useAdminStore = (set) => ({
    admins: [],
    addAdmin: (admin) => set((state) => void (state.admins.push(admin))),
    removeAdmin: (id) => set((state) => void (state.admins = state.admins.filter(admin => admin._id !== id))),
    addAllAdmins: (branch) => set((state) => { state.admins = branch.admins; state.branch = { ...branch, admins: undefined }; }),
    editAdmin: (admin) => set(state => {
        let foundAdmin = state.admins.find(ad => ad._id === admin._id);
        if (foundAdmin) {
            Object.assign(foundAdmin, admin);
        }
    }),
    branch: {},
    setBranch: (branch) => set((state) => void (state.branch = branch))
})
useAdminStore = devtools(useAdminStore, { name: "admins" });
useAdminStore = immer(useAdminStore);
export default create(useAdminStore);